import { AppKind, TellentClientBootstrapDataV2, TellentClientConfig } from '@core/tellent-types';

import { demoApp } from './demo-app';
import { AppKindNotRecognizedError, readBootstrapDataFromUrl } from './demo-helpers';
import type { TellentClient } from '../app/tellent-client';

declare global {
  interface Window {
    tellentClient: TellentClient;
    tellentClientConfig: TellentClientConfig;
    tellentClientData: Partial<TellentClientBootstrapDataV2> | null | void;
  }
}

try {
  const { appKind, baseHref } = readBootstrapDataFromUrl(window.location.toString());

  window['tellentClientConfig'] = {
    env: 'staging',
    oneDomainRedirect: false,
    navigationScope: ['recruitment', 'core_hr', 'grow', 'admin'],
    brand: 'javelo',
    toastCallbacks: {
      success: (message: string) => console.warn(message),
      error: (message: string) => console.warn(message),
    },
    baseHref,
  };

  window['tellentClient'] = demoApp(appKind, window['tellentClientConfig'], data => {
    window['tellentClientData'] = data;
  });
} catch (err) {
  if (err instanceof AppKindNotRecognizedError) {
    const base = document.head.querySelector('base')?.getAttribute('href') ?? '/';
    const defaultAppKind = AppKind.TellentAdmin;
    const newUrl = `${window.location.origin}${base}${defaultAppKind}/`;
    window.open(newUrl, '_self');
  }
}
